import { useEffect, useState } from "react";
import { apiPaths } from "../../service/apiPaths"
import ApiService from "../../service/ApiService"
import toast from "react-hot-toast";
import { GridColDef, GridFilterModel, GridSortModel } from "@mui/x-data-grid";

const useArticle = (columns: GridColDef[]) => {

  const [loading, setLoading] = useState(false);
  const [articleData, setArticleData] = useState<any[]>([])
  const [filterModel, setFilterModel] = useState<GridFilterModel>();
  const [sortingModel, setSortingModel] = useState<GridSortModel>();
  // New state for dedicated time sorting
  const [timeSortOrder, setTimeSortOrder] = useState<'asc' | 'desc' | null>(null);
  const [searchQuery, setSearchQuery] = useState<string>("");
  const [paginationModel, setPaginationModel] = useState({
    page: 0, // DataGrid is 0-indexed
    pageSize: 10,
  });
  const [rowCount, setRowCount] = useState(0); // Total number of rows

  // Debounced search effect
  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      getArticles();
    }, 500); // 500ms debounce delay

    return () => clearTimeout(debounceTimer);
  }, [searchQuery]);

  useEffect(() => {
    getArticles();
  }, [paginationModel, filterModel, sortingModel, timeSortOrder]); // Added timeSortOrder to dependencies

  // Effect to reset time sort when grid sort is used
  useEffect(() => {
    if (sortingModel && sortingModel.length > 0) {
      setTimeSortOrder(null);
    }
  }, [sortingModel]);

  const getArticles = async () => {
    try {
      const params: any = {
        page: paginationModel.page + 1,
        limit: paginationModel.pageSize,
        filters: filterModel?.items.map(({ field, operator, value }) => ({
          field,
          type: columns?.find((col) => col.field === field)?.type || "string",
          operator,
          value,
        })),
        // Prioritize timeSortOrder, otherwise use the grid's sortingModel
        sortBy: timeSortOrder ? "createdAt" : sortingModel?.[0]?.field || "",
        sortOrder: timeSortOrder || sortingModel?.[0]?.sort || undefined,
      };

      // Add search query parameter if provided
      if (searchQuery && searchQuery.trim().length > 0) {
        params.q = searchQuery.trim();
      }

      const data = await ApiService({
        method: "GET",
        endpoint: apiPaths.getArticles,
        params
      })
      console.log("Articles : ", data)

      if (data?.data) {
        // Transform data to display categories as comma-separated values
        const transformedData = data.data.map((article: any) => ({
          ...article,
          category: article.category_id && article.category_id.length > 0
            ? article.category_id.map((cat: any) => cat.category).join(', ')
            : article.category || '-'
        }));
        setArticleData(transformedData);
        setRowCount(data?.totalCount || 0);
      } else {
        setArticleData(data || []);
        setRowCount(0);
      }
    } catch (err) {
      console.log(err)
    }


  }


  const handleDelete = async (id: string) => {
    try {

      const data = await ApiService({
        method: "DELETE",
        endpoint: `${apiPaths.deleteArticle}/${id}`
      })
      console.log(data)
      toast.success("Article Deleted Successfully")
      getArticles();

    } catch (err) {
      toast.error("Error Occured")
    }
  }

  // New handler to cycle through time sorting options
  const handleSortByTime = () => {
    // When using this button, clear the grid's own sort model
    setSortingModel([]);
    setTimeSortOrder((prev) => {
      if (prev === "desc") return "asc";
      if (prev === "asc") return null; // Turn off
      return "desc"; // Start with descending
    });
  };

  return { getArticles, loading, articleData, searchQuery, setSearchQuery, handleDelete, setFilterModel, setSortingModel, rowCount, paginationModel, setPaginationModel, handleSortByTime, timeSortOrder }
}


export default useArticle